import {Modal} from '../index';
import {useDispatch} from 'react-redux';
import {closeModuleModal, redeemComebackReward} from '../../../../reducers/modules/actions';
import {navigate} from '../../../../utils/navigation';

export default ({modal, data}) => {
    const dispatch = useDispatch();

    return (
        <Modal>
            <div className="creative-header" style={{
                background: `url(${window.location.origin}/source/modules/modals/facebook/background.png)`,
                backgroundSize: 'cover'
            }}>
                <div className="close" onClick={e => dispatch(closeModuleModal())}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18 18L6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg> 
                </div>

                <div className="creative-shadow"></div>
            </div>

            <div className="modal-text" style={{marginTop: '-30px'}}>
                <div className="title">New Facebook post!</div>
                <div className="description" style={{textAlign: "center"}}>A new post is available in your Facebook bonus. Complete the task to earn your reward.</div>
            </div>

            <div className="block">
                <div className="modal-button blue" onClick={e => {
                    dispatch(closeModuleModal());
                    navigate('/tasks?redirect_from=facebook_modal');
                }}>
                    View task
                </div>
            </div>
        </Modal>
    )
} 